import { authenticatedJsonRequest } from "services/api";
import { WHOLSTER_REST_BASE_URL } from "services/config";

export const AFFILIATE_PAGE_SIZE = 50;

const affiliateRequest = (path, sessionId, options) =>
  authenticatedJsonRequest(
    `${WHOLSTER_REST_BASE_URL}/affiliates/admin${path}`,
    sessionId,
    options
  );

export const createAffiliate = (userId, name, sessionId) =>
  affiliateRequest("", sessionId, {
    method: "POST",
    body: JSON.stringify({ userId: Number(userId), name: name.trim() }),
  });

export const getAffiliate = (userId, sessionId, options) =>
  affiliateRequest(`/${userId}`, sessionId, options);

export const updateAffiliate = (userId, changes, sessionId) =>
  affiliateRequest(`/${userId}`, sessionId, {
    method: "PATCH",
    body: JSON.stringify(changes),
  });

export const getAffiliateUsers = (userId, offset, sessionId, options) =>
  affiliateRequest(
    `/${userId}/users?offset=${offset}&limit=${AFFILIATE_PAGE_SIZE}`,
    sessionId,
    options
  );
